import React, { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
const STORAGE_KEY = "larcraft_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (product, qty = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.product_id === product.id);
      const price = product.sale_price ?? product.price;
      const image = product.images?.[0] || "";
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + qty };
        return next;
      }
      return [...prev, { product_id: product.id, name: product.name, price, image, quantity: qty, slug: product.slug }];
    });
  };

  const removeItem = (product_id) => setItems((prev) => prev.filter((i) => i.product_id !== product_id));
  const updateQty = (product_id, qty) => setItems((prev) => prev.map((i) => i.product_id === product_id ? { ...i, quantity: Math.max(1, qty) } : i));
  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartCtx.Provider value={{ items, addItem, removeItem, updateQty, clear, subtotal, count }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
